import InputFooter from './input-footer';

export default InputFooter;

